import React, { useState } from 'react';

import { signInWithRedirect } from 'aws-amplify/auth';
import { useTranslation } from 'react-i18next';

import { ReactComponent as GoogleIcon } from '../../../../../../assets/icons/v3/google-icon.svg';
import { SRP_AUTH_FLOW } from '../../../../../../config/amplify';
import StyledCircularProgress from '../../../../../../shared/components/StyledCircularProgress/StyledCircularProgress';
import {
  ASSOCIATED_METHOD,
  CLICK_ACTION,
  ENTER_EMAIL,
  GOOGLE_METHOD
} from '../../../../../../shared/constants/tagManager';
import TagManagerService from '../../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATIONS_AUTH } from '../../../../../../shared/translations/auth';

interface GoogleButtonProps {
  gtmTag: typeof ASSOCIATED_METHOD | typeof ENTER_EMAIL;
}

const GoogleButton = ({ gtmTag }: GoogleButtonProps) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async () => {
    SRP_AUTH_FLOW();
    setLoading(true);
    TagManagerService.pushEvent(CLICK_ACTION, gtmTag, GOOGLE_METHOD);
    await signInWithRedirect({ provider: 'Google' });
  };

  return (
    <button className="login-button" onClick={handleSubmit}>
      {loading ? (
        <StyledCircularProgress />
      ) : (
        <div className="button-info">
          <GoogleIcon />
          <span className="description">{t(TRANSLATIONS_AUTH.loginCard.googleButtonText)}</span>
        </div>
      )}
    </button>
  );
};

export default GoogleButton;
